"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChargingSessionAttemptValidation = void 0;
const ChargingTransactionValidation_1 = require("./ChargingTransactionValidation");
const MembershipTransactionValidation_1 = require("./MembershipTransactionValidation");
const PaymentTransactionValidation_1 = require("./PaymentTransactionValidation");
const ChargingSessionMatchingPatternValidation_1 = require("./ChargingSessionMatchingPatternValidation");
class ChargingSessionAttemptValidation {
    static isValid(entity) {
        // Validate entity.id for existence and correct type.
        if (entity.id == undefined)
            return false;
        if (typeof entity.id !== "string")
            return false;
        // Validate entity.session_id for existence and correct type.
        if (entity.session_id == undefined)
            return false;
        if (typeof entity.session_id !== "string")
            return false;
        // If entity.payment_transaction_id exists, validate that it has the correct type.
        if (entity.payment_transaction_id != undefined) {
            if (typeof entity.payment_transaction_id !== "string")
                return false;
        }
        // If entity.payment_transaction exists, validate that it has the correct type.
        if (entity.payment_transaction != undefined) {
            if (!PaymentTransactionValidation_1.PaymentTransactionValidation.isValid(entity.payment_transaction))
                return false;
        }
        // If entity.charging_transaction_id exists, validate that it has the correct type.
        if (entity.charging_transaction_id != undefined) {
            if (typeof entity.charging_transaction_id !== "string")
                return false;
        }
        // If entity.charging_transaction exists, validate that it has the correct type.
        if (entity.charging_transaction != undefined) {
            if (!ChargingTransactionValidation_1.ChargingTransactionValidation.isValid(entity.charging_transaction))
                return false;
        }
        // If entity.membership_transaction_id exists, validate that it has the correct type.
        if (entity.membership_transaction_id != undefined) {
            if (typeof entity.membership_transaction_id !== "string")
                return false;
        }
        // If entity.membership_transaction exists, validate that it has the correct type.
        if (entity.membership_transaction != undefined) {
            if (!MembershipTransactionValidation_1.MembershipTransactionValidation.isValid(entity.membership_transaction))
                return false;
        }
        // If entity.matching_pattern exists, validate that it has the correct type.
        if (entity.matching_pattern != undefined) {
            if (!ChargingSessionMatchingPatternValidation_1.ChargingSessionMatchingPatternValidation.isValid(entity.matching_pattern))
                return false;
        }
        // If entity.receipt_expires_at exists, validate that it has the correct type.
        if (entity.receipt_expires_at != undefined) {
            if (!(entity.receipt_expires_at instanceof Date))
                return false;
        }
        // If entity.payment_can_be_captured exists, validate that it has the correct type.
        if (entity.payment_can_be_captured != undefined) {
            if (typeof entity.payment_can_be_captured !== "boolean")
                return false;
        }
        // If entity.membership_validation_skipped exists, validate that it has the correct type.
        if (entity.membership_validation_skipped != undefined) {
            if (typeof entity.membership_validation_skipped !== "boolean")
                return false;
        }
        return true;
    }
}
exports.ChargingSessionAttemptValidation = ChargingSessionAttemptValidation;
